import React from 'react'
import HeroImg from '../../assets/images/company-formation/offshore-company-formation/hero-img.png'
import BannerImg from '../../assets/images/company-formation/offshore-company-formation/banner-img.png'
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../components/Constant/List/List";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import Button from "../../components/Constant/button/Button";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import CTA from "../../components/Constant/cta/CTA";

const BreadCrumbsData = [
    {name: 'Offshore Advisory', link: '/'},
    {
        name: 'Singapore Company Formation',
        link: '/singapore-company-formation',
    },
]

function SingaporeCompanyFormation() {
    return (
        <main className='main'>
            <section className='section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>Singapore Company Formation</h1>
                    <br/>
                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>Incorporate in Asia’s Leading Business & Financial Hub</h3>
                            <p className='page-paragraph'>
                                A <b>Singapore Private Limited Company (Pte Ltd)</b> offers <b>tax advantages</b>, <b>investor confidence</b>, and <b>strategic market access</b>. <b>Singapore</b> is consistently ranked as one of the <b>best places to do business</b>, with <b>world-class infrastructure</b> and a <b>business-friendly legal system</b>.
                            </p>

                            <PageList
                                items={[
                                    {
                                        title: "Low Tax (17% corporate rate, exemptions apply)",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Strong Banking",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Global Credibility",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Gateway to Asia",
                                        icon: TiTick,
                                    },
                                ]}
                            />

                            <Button
                                text="Request a Singapore Company Formation Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImg}/>
                    </div>
                    <BannerPageImg src={BannerImg}/>
                    <br/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>Why Incorporate in Singapore?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Global Credibility",
                                    paragraph: "Tier-1 jurisdiction, trusted by banks & investors",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Low Taxes",
                                    paragraph: "17% corporate tax with partial exemptions, effective rates often lower",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Investor-Friendly",
                                    paragraph: "Strong double-tax treaty network",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Gateway to Asia",
                                    paragraph: "Perfect for regional headquarters",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Innovation Hub",
                                    paragraph: "Fintech, blockchain, and startup-friendly",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Types of Companies in Singapore</h3>
                        <p className='page-subtitle'>1. Private Limited Company (Pte Ltd)</p>
                        <PageList
                            items={[
                                { paragraph: "Most common structure.", icon: GoDotFill },
                                { paragraph: "Limited liability for shareholders.", icon: GoDotFill },
                                { paragraph: "Ideal for startups, SMEs, trading, fintech, and holding companies.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>2. Public Company (Limited by Shares or Guarantee)</p>
                        <PageList
                            items={[
                                { paragraph: "For large enterprises and organizations.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>3. Branch or Subsidiary</p>
                        <PageList
                            items={[
                                { paragraph: "For foreign companies expanding into Singapore.", icon: GoDotFill },
                            ]}
                        />

                        <h3 className='page-title'>Incorporation Requirements</h3>
                        <PageList
                            items={[
                                {
                                    title: "Shareholders",
                                    paragraph: "1–50 (individuals or corporates)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Directors",
                                    paragraph: "At least 1 must be a Singapore resident (citizen, PR, or EP holder)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Company Secretary",
                                    paragraph: "Required (local)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Registered Office",
                                    paragraph: "Must be in Singapore",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Minimum Share Capital",
                                    paragraph: "SGD 1",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Filing",
                                    paragraph: "Annual return + financial statements (audit thresholds apply)",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Benefits of Singapore Companies</h3>
                        <PageList
                            items={[
                                {
                                    title: "Reputation",
                                    paragraph: "Recognized globally as a premier business hub",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tax Efficiency",
                                    paragraph: "Exemptions & incentives for startups and holding companies",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Banking & PSP Access",
                                    paragraph: "Seamless banking integration",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Startup-Friendly",
                                    paragraph: "Ideal for tech, fintech, and venture-backed businesses",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Strong Legal System",
                                    paragraph: "Based on English common law",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Incorporation Process</h3>
                        <PageList
                            items={[
                                {
                                    title: "Consultation & Planning",
                                    paragraph: "Define structure and shareholders",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Name Reservation",
                                    paragraph: "Approval with ACRA",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Document Preparation",
                                    paragraph: "Constitution, shareholder & director info",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Filing with ACRA",
                                    paragraph: "Registration completed online",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Certificate of Incorporation",
                                    paragraph: "Issued after successful registration",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Bank Account Opening",
                                    paragraph: "Local or international banks",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Timeline & Costs</h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "3–7 business days",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Costs",
                                    paragraph: "From USD 3,500+",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Costs",
                                    paragraph: "Compliance, secretary, filing, audit if required",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Common Uses of Singapore Companies</h3>
                        <PageList
                            items={[
                                {
                                    title: "Regional Trading & Import/Export",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "FinTech & Blockchain Startups",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Fund Management & Asset Holding",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "International Consulting & Advisory",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Regional Headquarters for Multinationals",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Why Offshore Advisory?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Specialists in Singapore Incorporation & Compliance",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Network of Licensed Corporate Secretaries & Tax Advisors",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Expertise in Fintech, Fund Structuring, and Startup Planning",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Comparative Insights",
                                    paragraph: "Singapore vs Hong Kong vs UAE vs Mauritius",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Ongoing Annual Compliance & Substance Support",
                                    paragraph: "",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                    </div>

                    <FAQList title='Frequently Asked Questions (FAQ)' data={faqData} />

                    <Testimonials title='Client Testimonials' testimonials={testimonialsData}/>

                    <CTA
                        title="Looking for a Tier-1 Asian business hub?"
                        description=
                            "A <b>Singapore company</b> provides global credibility, low taxes, and access to the fast-growing Asian markets."
                        buttonText="Book a Singapore Company Formation Consultation →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    )
}

export default SingaporeCompanyFormation

const faqData = [
    {
        question: "Can foreigners own 100% of a Singapore company?",
        content: [
            { type: "answer", text: "Yes — full foreign ownership is allowed." },
        ],
    },
    {
        question: "Do I need a local director?",
        content: [
            { type: "answer", text: "Yes — at least one Singapore resident director is required." },
        ],
    },
    {
        question: "What is the tax rate?",
        content: [
            { type: "answer", text: "17% corporate tax, with partial exemptions reducing effective rates to as low as 3–8%." },
        ],
    },
    {
        question: "Do Singapore companies need audits?",
        content: [
            { type: "answer", text: "Only if revenue exceeds SGD 10M or total assets SGD 10M." },
        ],
    },
    {
        question: "How long does incorporation take?",
        content: [
            { type: "answer", text: "3–7 business days." },
        ],
    },
];


const testimonialsData = [
    {
        quote:
            "Our fintech startup registered in Singapore. Offshore Advisory guided us with incorporation, banking, and compliance.",
        author: "Li Wei.",
        role: "Entrepreneur",
    },
    {
        quote:
            "We used Singapore as our Asia HQ. Offshore Advisory helped us structure our company and manage ongoing filings.",
        author: "Michael D.",
        role: "Investor",
    },
];